import { render, staticRenderFns } from "./IconCamera.vue?vue&type=template&id=cf902df2&scoped=true"
import script from "./IconCamera.vue?vue&type=script&lang=js"
export * from "./IconCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf902df2",
  null
  
)

export default component.exports